module.exports = __webpack_public_path__ + "resources/icon-gift-default.27bbe437d5f23062.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/img/icon-gift-default.png
// module id = 833
// module chunks = 0 1